import { dictionaries } from "../lib/i18n";
import type { UiLang } from "../lib/types";
import type { PlaceLink } from "../utils/placeLink";

/**
 * Veien videre når nettsida ikke svarer.
 *
 * Halvparten av hotellene i datasettet har en nettside, og noen av dem er døde:
 * domenet er sagt opp, stedet har lagt ned, eller siden står i vedlikehold den
 * dagen man klikker. Fra nettleseren er de tre umulige å skille fra en side som
 * virker — et kall til et annet domene får ikke lese svaret, og et
 * `no-cors`-kall gir en ugjennomsiktig respons uten statuskode.
 *
 * Så vi gjetter ikke. Vi viser begge veier samtidig, og et kartsøk på navn og
 * koordinater finner stedet uansett hva som har skjedd med domenet. Det koster
 * én liten lenke i grensesnittet og sparer den reisende for en blindvei.
 *
 * Rendrer ingenting når det ikke finnes en nettside å falle fra: da *er*
 * hovedlenka allerede kartsøket, og to like lenker ved siden av hverandre er
 * bare støy. Se utils/placeLink.ts.
 */
export function PlaceAltLink({ link, lang }: { link?: PlaceLink; lang: UiLang }) {
  if (!link) return null;
  const t = dictionaries[lang];

  return (
    <a
      className="place-alt no-print"
      href={link.href}
      target="_blank"
      rel="noreferrer"
      title={t.placeAltHint}
    >
      {link.kind === "map" ? t.placeAlt : t.placeAltSearch}
    </a>
  );
}
